import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AccountStatus } from '../models/certificate.model';
import { StudentEmailModalService } from '../services/student-email-modal.service';

/**
 * Guard qui vérifie le statut du compte utilisateur
 * Bloque l'accès aux fonctionnalités de commande si:
 * - Statut RENOUVELLEMENT ou pas de statut (email étudiant requis)
 * - Ancien utilisateur sans email étudiant
 *
 * Déclenche la modal bloquante au lieu de rediriger
 */
export const restrictedAccessGuard: CanActivateFn = async (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const studentEmailModalService = inject(StudentEmailModalService);

  const user = storageService.getUser();

  if (!user) {
    // Pas d'utilisateur, laisser passer (etudiantGuard s'en occupera)
    return true;
  }

  // Certificat en attente de validation : accès normal le temps de la vérification
  if (user.statutcomptId === AccountStatus.ATTENTE) {
    return true;
  }

  // Vérifier si l'utilisateur est en statut RENOUVELLEMENT ou n'a pas de statut
  const isRenouvellement = user.statutcomptId === AccountStatus.RENOUVELLEMENT || user.statutcomptId == null;

  // Vérifier si l'utilisateur est un ancien utilisateur (certificat mais pas d'email)
  const isMigratingUser = !!(user.certi_scolarite && !user.email_etudiant);

  if (isRenouvellement || isMigratingUser) {
    console.log('[RestrictedAccessGuard] Accès refusé - Email étudiant requis');

    // Déclencher la modal bloquante (si pas déjà ouverte)
    await studentEmailModalService.showModalIfNeeded();

    // Rediriger vers la page d'accueil pour éviter de rester sur la page bloquée
    router.navigate(['/home']);

    return false;
  }

  // Accès autorisé
  return true;
};
